import { Identifiable, Tag, Task } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResourcesTags(
  { allocations }: Identifiable<Task>,
  { resourceTags }: Filter,
): boolean {
  return (
    !!resourceTags &&
    resourceTags.length > 0 &&
    !resourceTags.find((tag) =>
      allocations
        .reduce<
          Tag[]
        >((tags, { resource }) => [...tags, ...(resource.tags || [])], [])
        .find((t) => (t.name || t) === (tag.name || tag)),
    )
  );
}

export { isFilteredByResourcesTags };
